/**
 * This function return Icon status event marking
 @param {String} data - status event marking 
*/
const getIconStatus = (data = 'no change') => {
  if (!data) {
    return 'times'
  }
  const status = data.toLowerCase()
  if (status === 'no change' || status === 'error') {
    return ['fal', 'times']
  }
  if (status === 'editing') {
    return 'pencil'
  }
  if (status === 'saved') {
    return 'check'
  }
  if (status === 'saving') {
    return 'circle-notch'
  }
}

/**
 * This function return String status
 @param {Boolean} status - status 
*/
const generateLabelTypeList = (status) => {
  if (status) {
    return 'active'
  } else {
    return 'inactive'
  }
}



export {
  getIconStatus, generateLabelTypeList
}